import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type {
    AgendaItem,
    CreateAgendaItemData,
    UpdateAgendaItemData,
} from "../../managers/agenda/types/agenda";

export type Agenda = {
    getUserAgenda: (
        startDate: string,
        endDate: string,
    ) => Promise<AgendaItem[]>;
    createAgendaItem: (
        agendaItemData: CreateAgendaItemData,
    ) => Promise<boolean>;
    updateAgendaItem: (
        itemId: string,
        updateData: UpdateAgendaItemData,
    ) => Promise<boolean>;
    deleteAgendaItem: (itemId: string) => Promise<boolean>;
    acceptAgendaItem: (itemId: string) => Promise<boolean>;
    tentativelyAcceptAgendaItem: (itemId: string) => Promise<boolean>;
    declineAgendaItem: (itemId: string) => Promise<boolean>;
};

export function useAgenda(): Agenda {
    const { agendaManager } = useSdk();

    return useMemo<Agenda>(
        () => ({
            getUserAgenda: (...args) => agendaManager.getUserAgenda(...args),
            createAgendaItem: (...args) =>
                agendaManager.createAgendaItem(...args),
            updateAgendaItem: (...args) =>
                agendaManager.updateAgendaItem(...args),
            deleteAgendaItem: (...args) =>
                agendaManager.deleteAgendaItem(...args),
            acceptAgendaItem: (...args) =>
                agendaManager.acceptAgendaItem(...args),
            tentativelyAcceptAgendaItem: (...args) =>
                agendaManager.tentativelyAcceptAgendaItem(...args),
            declineAgendaItem: (...args) =>
                agendaManager.declineAgendaItem(...args),
        }),
        [agendaManager],
    );
}
